import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  PDF_CLEAR_ALL_STATE,
  PDF_LOAD_FAILURE,
  PDF_LOAD_START,
  PDF_LOAD_SUCCEED,
} from '@app/libs/reactPdfJs/store/actionTypes';

type ErrorMessageState = string | null;

const initialState: ErrorMessageState = null;

export default function reducer(state: ErrorMessageState = initialState, action: PdfAction) {
  switch (action.type) {
    case PDF_CLEAR_ALL_STATE:
    case PDF_LOAD_START:
    case PDF_LOAD_SUCCEED:
      return initialState;
    case PDF_LOAD_FAILURE: {
      return action?.payload?.message ?? null;
    }
    default:
      return state;
  }
}
